import m from 'mithril'

import InstallBapp from '../components/install-bapp'
import ModifyAccess from '../components/modify-access'

m.mount(document.getElementById('app'), {
  view: () =>
    m('.fullscreen',
      m(OAUTH_DATA.client.installed_at ? ModifyAccess : InstallBapp, {
        user: OAUTH_DATA.user,
        client: OAUTH_DATA.client,
        scopeDetails: OAUTH_DATA.scopeDetails,
        prevScopeDetails: OAUTH_DATA.prevScopeDetails,
        transaction_id: OAUTH_DATA.transaction_id,
      })
    )
})
